export default __webpack_public_path__ + "images/0f2469ed-pen-to-square-solid.svg";